export const SEARCH_REQUEST_PENDING = "SEARCH_REQUEST_PENDING";
export const SEARCH_DATA_FAILURE = "SEARCH_DATA_FAILURE";

//Get Shoes Data
export const GET_SEARCH_REQUEST_SUCCESSFUL = "GET SEARCH_REQUEST_SUCCESSFUL";

//Post Shoes Data
export const POST_SEARCH_REQUEST_SUCCESSFUL = "POST_SEARCH_REQUEST_SUCCESSFUL";